// extracted by mini-css-extract-plugin
module.exports = {"info":"Question_info__37K-R","center":"Question_center__33hmL","divider":"Question_divider__22A_7"};